import { render } from "./portfolio-layout.vue?vue&type=template&id=160a149a&scoped=true&ts=true"
import script from "./portfolio-layout.vue?vue&type=script&lang=ts"
export * from "./portfolio-layout.vue?vue&type=script&lang=ts"

import "./portfolio-layout.vue?vue&type=style&index=0&id=160a149a&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160a149a"]])

export default __exports__